export default __webpack_public_path__ + "static/media/arrow_svg.d99222f5.svg";